import React, { useEffect, useState, useContext } from "react";
import { useFetch } from "../../Utils/Hooks/useFetch";
import { appContext } from "../../AppContext";
import ButtonSSO from "../buttons/ButtonSSO";
import { Space, Divider } from "antd";
import { WindowsFilled } from "@ant-design/icons";
import MicrosoftSVG from "../buttons/microsoft_icon";
import PrequestSquareSVG from "../buttons/prequest_icon";
import { useTranslation } from 'react-i18next'

// list available external logins
export default function ExternalLogins({
  returnUrl: propsReturnUrl,
  token: propsToken,
  setIsExternalLoginLoading: propsSetIsExternalLoginLoading,
}) {
  const [appState] = useContext(appContext);
  const [externalLogins, setExternalLogins] = useState([]);
  const [doFetch, FetchType] = useFetch();
  const { t } = useTranslation(['utils'])

  const getIcon = {
    Windows: <WindowsFilled />,
    windows: <WindowsFilled />,
    Azure: <MicrosoftSVG />,
    azure: <MicrosoftSVG />,
    Microsoft: <MicrosoftSVG />,
    microsoft: <MicrosoftSVG />,
    Prequest: <PrequestSquareSVG />,
    prequest: <PrequestSquareSVG />,
    default: <WindowsFilled />,
  };

  useEffect(() => {
    if (propsReturnUrl === undefined) return;
    const getExternalLogins = async () => {
      const { isSuccess, result } = await doFetch(
        `/external/remoteAuthenticationSchemes?returnUrl=${encodeURIComponent(
          propsReturnUrl
        )}`,
        FetchType.GET
      );
      if (isSuccess) {
        setExternalLogins(result);

        const localStorageSSOName = localStorage.getItem("SSO.Autoselect");
        if (
          appState.isSSOAutoRedirect &&
          result.length > 0 &&
          localStorageSSOName
        ) {
          result.forEach((externalLogin) => {
            if (
              (externalLogin.displayName ?? externalLogin.name) ===
              localStorageSSOName
            ) {
              window.location = `${
                appState.baseUrl
              }/external/challenge?scheme=${
                externalLogin.name
              }&returnUrl=${encodeURIComponent(propsReturnUrl)}`;
            }
          });
        }
      }

      if (propsToken == null) {
        propsSetIsExternalLoginLoading(false);
      }
    };
    getExternalLogins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsReturnUrl]);

  const tokenReturnUrl = `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ""}${
    process.env.PUBLIC_URL
  }/result?code=211`;
  return (
    <>
      {externalLogins && externalLogins.length > 0 && (
        <>
          <Space direction="vertical" size="large" style={{ width: "100%", paddingTop: 16 }}>
            {externalLogins.map((externalLogin) => (
              <>
                <ButtonSSO
                  name={externalLogin.displayName ?? externalLogin.name}
                  href={
                    propsToken !== undefined
                      ? `${
                          appState.baseUrl
                        }/external/challengeToConnect?scheme=${
                          externalLogin.name
                        }&token=${encodeURIComponent(
                          propsToken
                        )}&returnUrl=${tokenReturnUrl}`
                      : `${appState.baseUrl}/external/challenge?scheme=${
                          externalLogin.name
                        }&returnUrl=${encodeURIComponent(propsReturnUrl)}`
                  }
                  key={externalLogin.name}
                  icon={getIcon[externalLogin.name]}
                />
              </>
            ))}
          </Space>

          {propsToken == null && (
            <Divider plain>{t("or")}</Divider>
          )}
        </>
      )}
    </>
  );
}
